/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "api";
import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import helpers from "util/helpers";

class CompetencyAndInterviewResult extends Component {
  rowClassName = "";
  state = {
    showingChildren: false,
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  downloadFile = (documentPath) => {
    this.props.setLoader(true);
    api
      .get(documentPath)
      .then((response) => {
        this.props.setLoader(false);
        const fileName = response.headers["content-disposition"].split(';')[1].split('=')[1];
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.setLoader(false);
      });
  };

  renderPasswordButton = (result) => {
    return (
      <button
        onClick={() => navigator.clipboard.writeText(result.password)}
        className="pass-link btn m-0 p-0"
      >
        <svg viewBox="0 0 612 792">
          <path
            fill="#CECECE"
            d="M183.6,273.6V151.2c0-33.66,27.54-61.2,61.2-61.2h306c33.8,0,61.2,27.4,61.2,61.2v306
c0,33.8-27.4,61.2-61.2,61.2H428.4V640.8c0,33.8-27.4,61.2-61.2,61.2h-306C27.4,702,0,674.6,0,640.8v-306
c0-33.66,27.54-61.2,61.2-61.2H183.6z M244.8,273.6h122.4c33.8,0,61.2,27.4,61.2,61.2v122.4H550.8v-306h-306V273.6z M61.2,334.8v306
h306v-306H61.2z"
          />
        </svg>
      </button>
    );
  };

  renderDownloadButton = (result) => {
    if (!result.documentPath || result.documentPath === "") return null;
    return (
      <button
        onClick={() => this.downloadFile(result.documentPath)}
        className="link-btn btn m-0 p-0"
      >
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
          <title>download-certificate</title>
          <path d="M112.41,93.07c0-7.8,12.27-7.8,12.27,0v23.41a6.51,6.51,0,0,1-6.32,6.31H31a6.51,6.51,0,0,1-6.32-6.31V93.07c0-7.8,12.64-7.8,12.64,0v17.09h75.09ZM80.07,84.89V28.09c0-7.06-10.78-7.06-10.78,0V85.27l-8.93-8.92c-4.83-5.2-12.26,2.6-7.43,7.43L70.77,102a5.68,5.68,0,0,0,7.44,0L96.42,83.78c5.21-5.2-2.6-12.63-7.8-7.43Z" transform="translate(-24.68 -22.79)"/>
        </svg>
      </button>
    );
  };

  renderTabletModeDetail = (result) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans>employee360_position</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {result.position ? result.position.name : ""}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    <Trans>employee360_password</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {this.renderPasswordButton(result)}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans>employee360_download</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {this.renderDownloadButton(result)}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { result } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr>
            <td className="showGrup">
              {result.document ? result.document.name : ""}
            </td>
            <td className="showGrup">{helpers.renderDate(result.createdOn)}</td>
            <td className="showGrup">
              {result.position ? result.position.name : ""}
            </td>
            <td>{this.renderPasswordButton(result)}</td>
            <td>{this.renderDownloadButton(result)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleChildren()}
          >
            <td className="showGrup">
              {result.document ? result.document.name : ""}
            </td>
            <td className="showGrup">{helpers.renderDate(result.createdOn)}</td>
          </tr>
          {this.renderTabletModeDetail(result)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {}
)(requireAuth(CompetencyAndInterviewResult));
